import {StyledAuth} from "./style";
import {MyButton, MyText} from "../../components";
import {Col, Flex, Form, Input, Row, message, Grid} from "antd";
import {LogoIcon} from "../../assets";
import {useMemo, useState, useEffect, useCallback} from "react";
import {MailOutlined, PhoneOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";
import {LANG_KEY} from "../../utils/constants/language";
import {MySegmented} from "../../components";
import { useNavigate } from 'react-router-dom';
import {useTranslation} from "react-i18next";
import { ROUTE_PATH } from "../../utils/"
import { useLang } from "../../utils/context/lang";
import InputMask from "react-input-mask";
import { fetchRestore } from "../../utils/";
import { useDispatch, useSelector } from "react-redux";
import { selectStore } from "../../utils/";
import { useEmbeddedLink } from "../../utils/context/embed";
import { useEmbeddedNavigate } from "../../utils/context/embed";
import { setRestoreData } from "../../utils/";
const FORM_NAME = {
  email: 'email',
  phone: 'phone',
};

const validatePhone = (phone) => {
  const phoneRegex = /^\+7\d{10}$/;
  return phoneRegex.test(phone);
};

export const RestorePageComponent = () => {
  const {t} = useTranslation("common")
  const {handleChangeLang, lang} = useLang()
  const dispatch = useDispatch();

  const [form] = Form.useForm();
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [currentKey, setCurrentKey] = useState<string>(FORM_NAME.email);
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();
  
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const {profile: {restoreData: restoreDataState}} = useSelector(selectStore)
  const embeddedLink = useEmbeddedLink();


  const handleSendCode = async () => {
    try {
      setErrorMessage(null);
      let username = currentKey === FORM_NAME.email ? email : phone;
      const type = currentKey === FORM_NAME.phone ? 2 : 1;
        
      if (currentKey === FORM_NAME.phone) {
        username = phone.replace(/\D/g, "");
        username = `${username}`;
      }
  
      const response = await dispatch(fetchRestore({ username, type }));
    
      if (response?.payload?.status === "success") {
        embeddedNavigate("/auth/restore/confirm")
      }
    } catch (error: any) {
      if (error.response?.data?.status === "error") {
        const errors = error.response.data.errors;
        if (errors && errors.length > 0) {
          setErrorMessage(errors.map((err: any) => err.message).join(" "));
        } else {
          setErrorMessage(error.response.data.message || t("codeSendError"));
        }
      } else {
        message.error(t("codeSendError"));
      }
    }
  };

  useEffect(() => {
    if (restoreDataState?.success) {
      embeddedNavigate("/auth/restore/confirm");
    } else if (restoreDataState?.failed && restoreDataState?.loading) {
      console.log(restoreDataState)
    }
  }, [restoreDataState]);


  const handleChangeLangSelect = useCallback((value: any) => {
      handleChangeLang(value)
    }, [])

  useEffect(() => {
      let formattedPhone = phone;
    
      if (phone.startsWith("8")) {
        formattedPhone = "+7" + phone.slice(1);
      }
    
      const cleanedPhone = formattedPhone.replace(/\D/g, "");
      const isEmailValid = email.includes("@");
      const isPhoneValid = cleanedPhone.startsWith("7") && cleanedPhone.length === 11;
    
      if (
        (currentKey === FORM_NAME.email && isEmailValid ) ||
        (currentKey === FORM_NAME.phone && isPhoneValid )
      ) {
        setIsButtonDisabled(false);
      } else {
        setIsButtonDisabled(true);
      }
    }, [email, phone, currentKey]);

  return (
    <StyledAuth>
      <div
        style={{
          position: 'absolute',
          top: 40,
          right: 40,
        }}
      >
        <MySegmented
          onChange={(value) => handleChangeLangSelect(value)}
          value={lang}
          options={[
          { label: 'ҚАЗ', value: LANG_KEY.KZ },
          { label: 'РУС', value: LANG_KEY.RU },
            ]}
          />
      </div>

      <Flex
        justify="center"
        align="center"
        style={{
          maxWidth: '500px',
          width: '100%',
        }}
      >
        <Row justify="center" gutter={[16, 16]}>
          <Col>
          <Link to={embeddedLink(ROUTE_PATH.MAIN)}>
            <LogoIcon />
            </Link>

          </Col>
          <Col span={24}>
            <Flex justify="center" style={{ maxWidth: '555px', width: '100%' }}>
              <MyText align="center" size={screens.xs ? 18 : 20} lineHeight={screens.xs ? '20px' : "32px"}>
                {t("passwordResetPrompt")}
              </MyText>
            </Flex>
          </Col>
          <Col span={24}>
            <Row justify="center">
              <Col>
                <MySegmented
                  onChange={(value) => setCurrentKey(value)}
                  type="primary"
                  options={[
                    {
                      label: `${t("email")}`,
                      value: FORM_NAME.email,
                    },
                    {
                      label: `${t("phone")}`,
                      value: FORM_NAME.phone,
                    },
                  ]}
                />
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Form
              form={form}
            >
              <Row>
              <Col span={24}>

              <Form.Item
            name={currentKey === FORM_NAME.email ? "email" : "phone" }
            labelCol={{ span: 24 }}
            style={{ marginBottom: 8, marginTop: 8 }}
            rules={[{ required: true, message: currentKey === FORM_NAME.phone ? t("enterPhoneNumber") : t("enterEmail") }]}
            validateStatus={restoreDataState?.data?.errors?.some((err) => err.field === "username") ? "error" : ""}
            help={restoreDataState?.data?.errors?.find((err) => err.field === "username")?.message}
          >
            {currentKey === FORM_NAME.email ? (
                <Col span={24}>
                  <MyText color="rgba(76, 76, 77, 1)" size={18} lineHeight={'24px'} weight={600}>
                    Email
                  </MyText>
                  <Input
                    prefix={<MailOutlined style={{ color: '#969BAB', marginRight: 8 }} />}
                    placeholder={t("enterEmail")}
                    value={email}
                    style={{ marginTop: 8 }}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Col>
              ) : (
                <Col span={24}>
                  <MyText color="rgba(76, 76, 77, 1)" size={18} lineHeight={'24px'} weight={600}>
                    {t("phone")}
                  </MyText>
                  <InputMask
                        mask="+7 (799) 999-99-99"
                        value={phone}
                        style={{ marginTop: 8 }}
                        onChange={(e) => {
                          const rawValue = e.target.value.replace(/\D/g, "").slice(1, 11);
                          setPhone(`+7 (${rawValue.slice(0, 3)}) ${rawValue.slice(3, 6)}-${rawValue.slice(6, 8)}-${rawValue.slice(8, 10)}`);
                        }}

                        maskChar=""
                      >
                        {(inputProps) => (
                          <Input
                            {...inputProps}
                            name="phone"
                            prefix={<PhoneOutlined style={{ color: "#969BAB", marginRight: 8 }} />}
                            placeholder="+7 (777) 777-77-77"
                          />
                        )}
                      </InputMask>
                      
                </Col>
              )}

              </Form.Item>
              </Col>

                <Col span={24} style={{marginTop: 36}}>
                  <Form.Item>
                    <MyButton
                      type="primary"
                      htmlType="submit"
                      color="orange"
                      style={{ width: '100%', fontSize: '18px' }}
                      disabled={isButtonDisabled}
                      onClick={handleSendCode}
                    >
                      {t("sendCode")} →
                    </MyButton>
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Flex justify="center">
                    <Form.Item>
                      <MyText color='#0A033C' size={screens.xs ? 16 : 20} lineHeight={'32px'}>
                      {t("rememberedPassword")}
                      </MyText>
                      <Link to={embeddedLink("/auth")}>
                        <MyText color="rgba(0, 141, 210, 1)" style={{ marginLeft: 5 }} size={screens.xs ? 16 : 20} lineHeight={'32px'}>
                          {t("loginWithPassword")}
                        </MyText>
                      </Link>
                    </Form.Item>
                  </Flex>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Flex>
    </StyledAuth>
  );
};
